import React from "react";
import { Select, MenuItem, styled } from "@mui/material";
import { getCompatibleUnits, convertUnits } from "../../utils/units";

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 24,
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    fontSize: "0.875rem",
    "&:focus": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

interface UnitSelectProps {
  value: string;
  onChange: (value: string) => void;
  sourceUnit?: string;
  disabled?: boolean;
}

export const UnitSelect: React.FC<UnitSelectProps> = ({
  value,
  onChange,
  sourceUnit,
  disabled = false,
}) => {
  const compatibleUnits = sourceUnit ? getCompatibleUnits(sourceUnit) : [];

  return (
    <StyledSelect
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      variant="outlined"
      size="small"
      disabled={disabled}
    >
      {compatibleUnits.map((unit) => (
        <MenuItem key={unit} value={unit}>
          {unit}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};
